export enum BUS_MESSAGE_KEY {
  LOADER = 'loader',
  USER_DETAILS = 'user_details',
  PRIVACY_STATUS = 'privacy_status'
}
